import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { FactoryExportsDashboardQueryKeys } from "modules/FactoryExportsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { FactoryExportPayload } from "modules/FactoryExportsDashboard/components/ExportModal/hooks/useAddExportMutation";

export const useUpdateExportMutation = () =>
  useTypedMutation<FactoryExportPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/exports/update", payload, ENV.reportsBaseURL);
    },
    onSuccess: payload => {
      const exports = typedQueryClient.getQueryData(FactoryExportsDashboardQueryKeys.exports);
      if (!exports) return;

      const exportIdx = exports.findIndex(factoryExport => factoryExport.id === payload.id);
      if (exportIdx === -1) return;

      const previousExport = exports[exportIdx];
      typedQueryClient.setQueryData(
        FactoryExportsDashboardQueryKeys.exports,
        exports.with(exportIdx, { ...previousExport, ...payload, id: previousExport.id, updated_on: toISOString(new Date()) })
      );
    }
  });
